import { put, takeLatest } from 'redux-saga/effects';
import handleException from './../services/handleException';
import { savePrinter } from './../utils/settingPrinter';
function* savePrinterHandle(data) {
    try {
        const json = yield savePrinter(data.payload)
        yield put({ type: 'SAVE_PRINTER_SUCCESS', json: json.result })
    } catch (error) {
        handleException(error)
        yield put({ type: 'SAVE_PRINTER_FAILURE', error })
    }
}

function* settingPrinterSaga() {
    yield takeLatest('ON_SAVE_PRINTER', savePrinterHandle)
}

export default settingPrinterSaga



// WEBPACK FOOTER //
// ./src/sagas/settingPrinterSaga.js